<div class="support-ticket-chat-container">
  <div class="sticky-header">
    <div class="message-avatar">
      <dk-seed-icon-native></dk-seed-icon-native>
    </div>
    <div class="sticky-header-text">
      <span class="title">
        {{ 'doktar_app.support_ticket.welcome.hi_name' | translate: { arg1: userFirstName } }}
      </span>
      <span class="subtitle">{{ 'doktar_app.support_ticket.welcome.how_can_we_help' | translate }}</span>
      <span class="description">{{ 'doktar_app.support_ticket.welcome.description' | translate }}</span>
    </div>
  </div>

  <div class="conversation">
    @if (loadError) {
      <div class="load-error-state">
        <dk-warning-circule-icon></dk-warning-circule-icon>
        <span class="error-title">{{ 'doktar_app.support_ticket.error.load_failed_title' | translate }}</span>
        <span class="error-subtitle">{{ 'doktar_app.support_ticket.error.load_failed_subtitle' | translate }}</span>
        <dk-button
          [label]="'doktar_app.support_ticket.error.try_again' | translate"
          [size]="'medium'"
          [severity]="'primary'"
          (onClick)="retryLoadInquiry()"></dk-button>
      </div>
    } @else {
      <div class="messages-container" #messageContainer>
        <div class="message-content-container greeting-message">
          <div class="message-avatar-spacer" aria-hidden="true"></div>
          <div class="message greeting">
            <div class="message-content">
              <div class="quick-actions">
                @for (action of quickActions; track action.key) {
                  <button
                    type="button"
                    class="quick-action-box"
                    [class.selected]="selectedQuickActionKey === action.key"
                    [class.inert]="(!!inquiryId && selectedQuickActionKey !== action.key) || loadingInquiryTypes"
                    (click)="selectQuickAction(action)">
                    {{ action.label }}
                  </button>
                }
              </div>
            </div>
            <div class="footer">
              <p class="ai-disclaimer">
                {{ formatMessageTime(greetingTimestamp) }}
                •
                {{ 'doktar_app.communications.chat_response_by_ai' | translate }}
                <span class="ai-disclaimer-brand">
                  <dk-generic-seed-icon></dk-generic-seed-icon>
                  <span>| Doktar AI.</span>
                </span>
              </p>
            </div>
          </div>
        </div>

        @if (loadingInquiry) {
            @for (item of [1, 2, 3]; track item) {
              <div class="message-content-container skeleton-message" [class.isByMe]="item % 2 === 0">
                <div class="message" [class.isByMe]="item % 2 === 0">
                  <dk-skeleton
                    [skeletonConfig]="{ size: item === 1 ? 3 : 2, layout: 'vertical', width: '220px', height: '16px' }"></dk-skeleton>
                </div>
              </div>
            }
          } @else {
            @for (message of inquiry.inquiryCorrespondences; track message.id; let i = $index) {
              @if (shouldShowDateSeparator(i)) {
                <div class="date-separator">
                  <span>{{ formatDateSeparator(message.createdAt) }}</span>
                </div>
              }
              <div class="message-content-container">
                @if (!message.isByMe) {
                  <div class="message-avatar">
                    <dk-seed-icon-native></dk-seed-icon-native>
                  </div>
                }
                <div class="message" [class.isByMe]="message.isByMe">
                  <div class="message-content">
                    @if (message.correspondenceType === 'AI') {
                      @if (!message.inquiryContent && showTypingIndicator && i === (inquiry.inquiryCorrespondences?.length ?? 0) - 1) {
                        <dk-typing></dk-typing>
                      } @else {
                        <div class="message-text markdown-content" [innerHTML]="renderedContents[message.id]"></div>
                      }
                    } @else if (message.inquiryContent?.trim()) {
                      <span class="message-text">{{ message.inquiryContent }}</span>
                    }
                    @if (message.fileUrl) {
                      <div class="message-file">
                        <img [src]="message.fileUrl" alt="uploaded file" />
                      </div>
                    }

                    <!-- Interactive picker: only while this exact message is
                         still awaiting a choice (there can be at most one,
                         and it's always the most recent AI message). -->
                    @if (message.id === pendingUiAction?.messageId) {
                      @if (pendingUiAction?.actionType === 'plantation.request_selection') {
                        <div class="ui-action-card ui-action-card--interactive">
                          @if (loadingPlantations) {
                            <dk-skeleton
                              [skeletonConfig]="{ size: 1, layout: 'horizontal', width: '100%', height: '48px' }"></dk-skeleton>
                          } @else {
                            <span class="dk-field-select-field-label">
                              {{ 'doktar_app.services.plantation' | translate }}
                            </span>
                            <p-select
                              [options]="plantationsGroupedByLands"
                              [placeholder]="'doktar_app.services.plantation' | translate"
                              [group]="true"
                              [filter]="true"
                              [filterBy]="'label'"
                              [filterPlaceholder]="'doktar_app.common.search_placeholder' | translate"
                              [dropdownIcon]="'ph ph-caret-down'"
                              [styleClass]="'dk-field-select'"
                              [panelStyleClass]="'dk-field-select-panel'"
                              [appendTo]="'body'"
                              (onChange)="onPlantationSelectedForUiAction($event)">
                              <ng-template let-group pTemplate="group">
                                <div class="dk-field-select-group-name">
                                  <span class="dk-field-select-group-label">{{ group.label }}</span>
                                </div>
                              </ng-template>
                              <ng-template let-item pTemplate="item">
                                <div class="dk-field-select-row">
                                  <div class="dk-field-select-row-media">
                                    <img [src]="item.value.image" alt="" />
                                  </div>
                                  <div class="dk-field-select-row-info">
                                    <div class="dk-field-select-row-title">
                                      <span class="dk-field-select-row-dot" [style.background]="item.value.cropColor"></span>
                                      <span>{{ item.value.name }}</span>
                                    </div>
                                    <div class="dk-field-select-row-details">
                                      <span>{{ item.value.totalAreaDisplay }}</span>
                                      @if (item.value.cropName) {
                                        <span class="dk-field-select-row-sep">∙</span>
                                        <span>{{ item.value.cropName }}</span>
                                      }
                                    </div>
                                  </div>
                                  <span
                                    class="dk-field-select-radio"
                                    [class.checked]="item.value.plantationId === selectedUiActionId"></span>
                                </div>
                              </ng-template>
                            </p-select>
                          }
                        </div>
                      } @else if (pendingUiAction?.actionType === 'inventory.request_selection') {
                        <div class="ui-action-card ui-action-card--interactive">
                          @if (loadingDevices) {
                            <dk-skeleton
                              [skeletonConfig]="{ size: 1, layout: 'horizontal', width: '100%', height: '48px' }"></dk-skeleton>
                          } @else {
                            <p-select
                              [options]="devices"
                              [filter]="true"
                              [filterBy]="'label'"
                              [filterPlaceholder]="'doktar_app.common.search_placeholder' | translate"
                              [dropdownIcon]="'ph ph-caret-down'"
                              [styleClass]="'dk-field-select'"
                              [panelStyleClass]="'dk-field-select-panel'"
                              [appendTo]="'body'"
                              (onChange)="onDeviceSelectedForUiAction($event)">
                              <ng-template let-item pTemplate="item">
                                <div class="dk-field-select-row">
                                  <div class="dk-field-select-row-info">
                                    <div class="dk-field-select-row-title">
                                      <span>{{ item.value.name }}</span>
                                    </div>
                                    <div class="dk-field-select-row-details">
                                      <span>{{ item.value.productionId }}</span>
                                    </div>
                                  </div>
                                  <span
                                    class="dk-field-select-radio"
                                    [class.checked]="item.value.deviceId === selectedUiActionId"></span>
                                </div>
                              </ng-template>
                            </p-select>
                          }
                        </div>
                      }
                    }

                    <!-- Resolved/read-only echo of an already-answered
                         selection - stays here for the rest of the chat,
                         through the real answer streaming in and across
                         reloads (driven by resolvedUiActionSelections, not
                         by whether this is still the last message). -->
                    @if (resolvedUiActionSelections[message.id]?.actionType === 'plantation.request_selection') {
                      <div class="ui-action-card">
                        <span class="dk-field-select-field-label">
                          {{ 'doktar_app.services.plantation' | translate }}
                        </span>
                        <div class="dk-field-select-resolved">
                          @if (getResolvedPlantation(resolvedUiActionSelections[message.id].selectedId); as resolvedPlantation) {
                            <span class="dk-field-select-row-dot" [style.background]="resolvedPlantation.cropColor"></span>
                            <span class="dk-field-select-resolved-label">{{ resolvedPlantation.name }}</span>
                          }
                          <i class="ph ph-caret-up"></i>
                        </div>
                      </div>
                    } @else if (resolvedUiActionSelections[message.id]?.actionType === 'inventory.request_selection') {
                      <div class="ui-action-card">
                        <div class="dk-field-select-resolved">
                          <span class="dk-field-select-resolved-label">{{
                            getResolvedDevice(resolvedUiActionSelections[message.id].selectedId)?.name
                          }}</span>
                          <i class="ph ph-caret-up"></i>
                        </div>
                      </div>
                    }
                  </div>
                  <div class="footer" [class.isByDoktar]="!message.isByMe">
                    <p class="ai-disclaimer">
                      {{ formatMessageTime(message.createdAt) }}
                      @if (shouldShowAiDisclaimer(message)) {
                        •
                        {{ 'doktar_app.communications.chat_response_by_ai' | translate }}
                        <span class="ai-disclaimer-brand">
                          <dk-generic-seed-icon></dk-generic-seed-icon>
                          <span>| Doktar AI.</span>
                        </span>
                      }
                    </p>
                  </div>
                </div>
              </div>

              @if (message.id === streamErrorMessageId) {
                <div class="stream-error-row">
                  <span>{{ 'doktar_app.support_ticket.error.response_failed' | translate }}</span>
                  <button type="button" class="retry-icon" (click)="retryLastTurn()">
                    <i class="ph ph-arrow-clockwise"></i>
                  </button>
                </div>
              }

              <!-- "You have selected X, your answer is getting generated."
                   confirmation row - a locally-derived echo of the same
                   message's resolvedUiActionSelections entry, not a
                   separate backend correspondence. -->
              @if (resolvedUiActionSelections[message.id]; as resolvedSelection) {
                <div class="message-content-container selection-confirmation-message">
                  <div class="message-avatar">
                    <dk-seed-icon-native></dk-seed-icon-native>
                  </div>
                  <div class="message">
                    <div class="message-content">
                      @if (resolvedSelection.actionType === 'plantation.request_selection') {
                        @if (getResolvedPlantation(resolvedSelection.selectedId); as resolvedPlantation) {
                          <span class="message-text">
                            {{
                              'doktar_app.support_ticket.chat.selection_confirmation'
                                | translate: { arg1: resolvedPlantation.name }
                            }}
                          </span>
                          <div class="dk-selection-summary-card">
                            <span class="dk-selection-summary-title">{{ resolvedPlantation.landName }}</span>
                            <div class="dk-field-select-row">
                              <div class="dk-field-select-row-media">
                                <img [src]="resolvedPlantation.image" alt="" />
                              </div>
                              <div class="dk-field-select-row-info">
                                <div class="dk-field-select-row-title">
                                  <span class="dk-field-select-row-dot" [style.background]="resolvedPlantation.cropColor"></span>
                                  <span>{{ resolvedPlantation.name }}</span>
                                </div>
                                <div class="dk-field-select-row-details">
                                  <span>{{ resolvedPlantation.totalAreaDisplay }}</span>
                                  @if (resolvedPlantation.cropName) {
                                    <span class="dk-field-select-row-sep">∙</span>
                                    <span>{{ resolvedPlantation.cropName }}</span>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      } @else if (resolvedSelection.actionType === 'inventory.request_selection') {
                        @if (getResolvedDevice(resolvedSelection.selectedId); as resolvedDevice) {
                          <span class="message-text">
                            {{
                              'doktar_app.support_ticket.chat.selection_confirmation'
                                | translate: { arg1: resolvedDevice.name }
                            }}
                          </span>
                          <div class="dk-selection-summary-card">
                            <div class="dk-field-select-row">
                              <div class="dk-field-select-row-info">
                                <div class="dk-field-select-row-title">
                                  <span>{{ resolvedDevice.name }}</span>
                                </div>
                                <div class="dk-field-select-row-details">
                                  <span>{{ resolvedDevice.productionId }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      }
                    </div>
                    <div class="footer isByDoktar">
                      <p class="ai-disclaimer">
                        {{ formatMessageTime(message.createdAt) }}
                        @if (!isStreaming) {
                          •
                          {{ 'doktar_app.communications.chat_response_by_ai' | translate }}
                          <span class="ai-disclaimer-brand">
                            <dk-generic-seed-icon></dk-generic-seed-icon>
                            <span>| Doktar AI.</span>
                          </span>
                        }
                      </p>
                    </div>
                  </div>
                </div>
              }
            }
          }
        </div>
      }

      <div class="chat-bar">
        @if (uploadedFileId) {
          <div class="uploaded-files">
            <div class="file-preview">
              <span class="file-name">{{ uploadedFile.name }}</span>
              <dk-button
                [icon]="'ph ph-x'"
                [size]="'medium'"
                [text]="true"
                [severity]="'secondary'"
                (click)="clearMessage()"></dk-button>
            </div>
          </div>
        }
        <form [formGroup]="messageForm" (ngSubmit)="sendMessage()" (keydown.enter)="sendMessage()">
          <div class="input-container">
            <dk-button
              [icon]="'ph-bold ph-plus'"
              [size]="'medium'"
              [text]="false"
              [severity]="'secondary'"
              [disabled]="sendingMessage || loadingInquiry || isStreaming || !!pendingUiAction || !!pendingRetry"
              (click)="openAttachPopover($event)"></dk-button>
            <dk-input
              col="8"
              name="message"
              [type]="'text'"
              style="flex: 1 0 0"
              [formGroup]="messageForm"
              [controlName]="'message'"
              [placeholder]="'doktar_app.support_ticket.chat.message_placeholder' | translate"
              [disabled]="sendingMessage || loadingInquiry || isStreaming || !!pendingUiAction || !!pendingRetry"></dk-input>
            <dk-button
              [icon]="sendingMessage ? null : 'ph ph-arrow-up'"
              [text]="false"
              [size]="'medium'"
              [severity]="'primary'"
              [disabled]="!canSendMessage"
              [loading]="sendingMessage"
              type="submit"></dk-button>
          </div>
        </form>
      </div>
    </div>
</div>

<p-popover #uploadFilePopover [appendTo]="'body'">
  <div class="upload-file-popover">
    <p-fileUpload
      mode="basic"
      [chooseLabel]="'doktar_app.support_ticket.chat.upload_file' | translate"
      [accept]="acceptedFileTypes"
      [maxFileSize]="maxFileSize"
      [auto]="true"
      [showUploadButton]="true"
      [showCancelButton]="false"
      [customUpload]="true"
      (uploadHandler)="customUploadHandler($event)"></p-fileUpload>
  </div>
</p-popover>
